import React from 'react';
import { integrations } from '../mockData';

const Integrations = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-purple-600 mb-4">
            Seamless Platform Integrations
          </h2>
          <p className="text-xl text-purple-500">
            Connect your store in minutes. We integrate with all major ecommerce platforms.
          </p>
        </div>

        {/* Integration Logos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {integrations.map((integration, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-200 flex items-center justify-center group border border-gray-100 hover:border-gray-300"
            >
              <span className="text-lg font-bold text-purple-600 group-hover:text-purple-600 transition-colors duration-200">
                {integration.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Integrations;
